import React from 'react';
import './App.css';
import Main from './page/main';

function App() {
  return <Main />;
}

export default App;
